<template>
  <div class="k-collapse-section">
    <div class="px-3 py-1 d-flex my-auto w-100">
      <p class="text-overline my-auto">{{ title }}</p>
      <v-spacer></v-spacer>
      <v-btn variant="text" icon size="small" class="btn btn-sm d-flex align-center" @click="toggle">
        <span v-if="isOpen" class="my-auto d-flex">
          <ui-icon name="chevron-down"></ui-icon>
        </span>
        <span v-else class="my-auto d-flex">
          <ui-icon name="chevron-right"></ui-icon>
        </span>
      </v-btn>
    </div>

    <v-expand-transition>
      <div class="pa-2" v-show="isOpen">
        <slot></slot>
      </div>
    </v-expand-transition>
    <v-divider></v-divider>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: this.open, // Lokale kopie van de prop
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    // Zorgt ervoor dat als de `open` prop verandert, de lokale `isOpen` wordt geüpdatet
    open(newVal) {
      this.isOpen = newVal;
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
